import React, { useEffect } from "react"
import { Switch, Route, useRouteMatch } from "react-router-dom"
import CartBody from "../components/Cart/Body"
import CartConfirm from "../components/Cart/Confirm"
import PageTitle from "../components/UI/PageTitle"
import mixpanel from "mixpanel-browser"

function Cart() {
  const { path } = useRouteMatch()
  useEffect(() => {
    mixpanel.track("Products Loaded")
  }, [])

  return (
    <div>
      <PageTitle>Kosár</PageTitle>
      <Switch>
        <Route exact path={path} component={CartBody} />
        <Route path={`${path}/:orderId`} component={CartConfirm} />
      </Switch>
    </div>
  )
}

export default Cart
